import apiClient from './apiClient';

/**
 * Servicio de trofeos/premios: listado público (genéticas con sus copas) y CRUD admin.
 */

const BASE = '/trophies';
const ADMIN_BASE = '/trophies/admin/items';

/** Extrae un mensaje legible de un error de axios. */
const errMsg = (error, fallback) => {
  const data = error?.response?.data;
  if (!data) return fallback;
  if (typeof data === 'string') return data;
  if (Array.isArray(data)) return data.join(' · ');
  if (typeof data.detail === 'string') return data.detail;
  if (typeof data.error === 'string') return data.error;
  const first = Object.values(data)[0];
  if (Array.isArray(first)) return first[0];
  if (typeof first === 'string') return first;
  return fallback;
};

// ─── Público ───────────────────────────────────────────────────────────────

export async function fetchPublicTrophies() {
  const { data } = await apiClient.get(`${BASE}/`);
  return data.trophies || [];
}

// ─── Admin (staff) ─────────────────────────────────────────────────────────

export async function fetchAdminTrophies() {
  const { data } = await apiClient.get(`${ADMIN_BASE}/`);
  return data; // DRF: lista plana (pagination off)
}

export async function createTrophy(payload) {
  try {
    const { data } = await apiClient.post(`${ADMIN_BASE}/`, payload);
    return data;
  } catch (error) {
    throw new Error(errMsg(error, 'Error al crear la genética'));
  }
}

export async function updateTrophy(id, payload) {
  try {
    const { data } = await apiClient.patch(`${ADMIN_BASE}/${id}/`, payload);
    return data;
  } catch (error) {
    throw new Error(errMsg(error, 'Error al actualizar la genética'));
  }
}

export async function deleteTrophy(id) {
  try {
    await apiClient.delete(`${ADMIN_BASE}/${id}/`);
  } catch (error) {
    throw new Error(errMsg(error, 'Error al eliminar la genética'));
  }
}

export async function uploadTrophyLogo(file) {
  const formData = new FormData();
  formData.append('image', file);
  try {
    const { data } = await apiClient.post(`${ADMIN_BASE}/upload-logo/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data.image_url;
  } catch (error) {
    throw new Error(errMsg(error, 'Error al subir el logo'));
  }
}
